'use strict';

var _ = require('lodash');
var toastr = require('toastr');
var SystemStatusMarketReoptController = function SystemStatusMarketReoptController($scope, systemStatusCommonRendererFactory, systemStatusMarketReoptRetrieverService) {
  $scope.customRenderers = systemStatusCommonRendererFactory;
  $scope.loadData = function () {
    return systemStatusMarketReoptRetrieverService.getData().then(function (response) {
      return systemStatusMarketReoptRetrieverService.transform(response);
    });
  };
  $scope.cancelOptimization = function (event, selectedRows) {
    systemStatusMarketReoptRetrieverService.cancelOptimization(_.map(selectedRows, 'messageKey')).then(function (response) {
      _.times(response.persistedCount, function () {
        toastr.success('Optimization cancelled successfully');
      });
      _.times(response.failedCount, function () {
        toastr.warning('Cannot cancel optimization');
      });
      $scope.$broadcast('grid:clearAndLoadData:system-status-market-reopt');
    });
  };
};
SystemStatusMarketReoptController.$inject = ['$scope', 'SystemStatusCommonRendererFactory', 'SystemStatusMarketReoptRetrieverService'];
module.exports = SystemStatusMarketReoptController;